import type { CashFlowDayForecast } from '@shared/api';
import { Badge } from '@shared/ui/Badge';
import { Table } from '@shared/ui/Table';
import { formatDateRu, formatMoney } from '../financierFormat';
import {
  Section,
  SectionHeader,
  SectionTitle,
  SectionHeaderSub,
  TableWrap,
  CashGapTr,
  DateTd,
  InflowsTd,
  OutflowsTd,
  NetFlowTd,
  ClosingBalanceTd,
  EmptyTableNoticeTd,
} from './styled';

interface CashForecastSectionProps {
  forecast: CashFlowDayForecast[] | undefined;
}

export function CashForecastSection({ forecast }: CashForecastSectionProps) {
  return (
    <Section>
      <SectionHeader>
        <SectionTitle>30-дневный платёжный календарь и прогноз ликвидности</SectionTitle>
        <SectionHeaderSub>
          Ежедневный расчёт денежного потока: план поступлений (КС-3) vs план списаний (платежи, ФОТ, налоги)
        </SectionHeaderSub>
      </SectionHeader>
      <TableWrap>
        <Table>
          <thead>
            <tr>
              <th>Дата</th>
              <th>Входящий остаток</th>
              <th>План прихода (КС-3/авансы)</th>
              <th>План расхода (заявки/ФОТ)</th>
              <th>Чистый поток</th>
              <th>Прогноз остатка</th>
              <th>Статус ликвидности</th>
            </tr>
          </thead>
          <tbody>
            {forecast && forecast.length > 0 ? (
              forecast.map((day, idx) => {
                const net = day.planned_inflows - day.planned_outflows;
                return (
                  <CashGapTr key={idx} $isGap={day.is_cash_gap}>
                    <DateTd>{formatDateRu(day.date)}</DateTd>
                    <td>{formatMoney(day.opening_balance)}</td>
                    <InflowsTd>
                      +{formatMoney(day.planned_inflows)}
                    </InflowsTd>
                    <OutflowsTd>
                      −{formatMoney(day.planned_outflows)}
                    </OutflowsTd>
                    <NetFlowTd $positive={net >= 0}>
                      {net >= 0 ? `+${formatMoney(net)}` : formatMoney(net)}
                    </NetFlowTd>
                    <ClosingBalanceTd>{formatMoney(day.closing_balance)}</ClosingBalanceTd>
                    <td>
                      {day.is_cash_gap ? (
                        <Badge $tone="danger">Кассовый разрыв!</Badge>
                      ) : (
                        <Badge $tone="success">Норма</Badge>
                      )}
                    </td>
                  </CashGapTr>
                );
              })
            ) : (
              <tr>
                <EmptyTableNoticeTd colSpan={7}>
                  Нет данных календаря
                </EmptyTableNoticeTd>
              </tr>
            )}
          </tbody>
        </Table>
      </TableWrap>
    </Section>
  );
}
